"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "What is included in a standard home inspection?",
  answer: "Our comprehensive inspections cover the home's structure, roof, electrical system, plumbing, and HVAC. We examine every accessible area from the foundation to the attic to ensure your investment is sound and safe."
}, {
  question: "How long does a typical inspection take?",
  answer: "A standard home inspection usually takes between 2 to 4 hours, depending on the size and condition of the property. We take the time necessary to provide a thorough evaluation and answer any questions you have on-site."
}, {
  question: "Do I need to be present during the inspection?",
  answer: "While not required, we highly recommend being present for the final hour. This allows our inspector to walk you through the findings, explain maintenance tips, and provide immediate clarity on any identified issues."
}, {
  question: "When will I receive my inspection report?",
  answer: "You will receive a detailed, digital report with high-resolution photos and clear explanations within 24 hours of the inspection. Our reports are easy to read and accessible from any mobile device or computer."
}, {
  question: "What happens if the report reveals issues?",
  answer: "No home is perfect. If issues are found, our report provides an objective assessment of their severity. This information empowers you to make informed decisions during negotiations or plan for future repairs."
}];
export default function AccountFaqs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="271" id="frequently-asked-questions" ref={ref} className={cn("relative w-full py-24 overflow-hidden bg-background text-foreground transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,hsl(var(--primary)/0.05),transparent_70%)]" />
        <div className="absolute inset-0 opacity-[0.02] mix-blend-overlay" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} />
      </div>

      <div className="container relative mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mx-auto max-w-3xl">
          <h2 className="mb-12 text-center font-sans text-4xl md:text-5xl leading-tight tracking-tight text-foreground uppercase">
            Frequently Asked Questions
          </h2>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-muted last:border-0" data-index={i}>
                <AccordionTrigger className="py-6 text-lg font-medium transition-colors duration-300 hover:no-underline text-secondary data-[state=open]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base font-sans font-normal leading-relaxed text-muted-foreground pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}